export * from './hire-page-details.backend-model';
export * from './hire-page-details.model';
export * from './hire-page-details.module';
export * from './hire-page-details.types';
